module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__stock",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-left"
  }, [(_vm.stock.name) ? _c('span', [_vm._v(" " + _vm._s('Склад ' + _vm.stock.name) + " ")]) : _c('span', [_vm._v(" Новый склад ")])]), _vm._v(" "), _c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), (_vm.stock.id && _vm.stock.id != 'new') ? _c('FlexTabs', {
    attrs: {
      "tabs": _vm.tabs,
      "min": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab-stock') ? _c('div', [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2'),
      expression: "'required|min:2'"
    }],
    attrs: {
      "required": true,
      "name": "name",
      "id": "name",
      "label": "Название",
      "placeholder": "Введите название склада",
      "data-vv-name": "name",
      "data-vv-as": ' ',
      "error": _vm.errors.first('name')
    },
    model: {
      value: (_vm.stock.name),
      callback: function($$v) {
        _vm.$set(_vm.stock, "name", $$v)
      },
      expression: "stock.name"
    }
  }), _vm._v(" "), _c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "callback": _vm.getCities,
      "length-on-search": 3,
      "update-on-input": true,
      "default": (_vm.stock.city && _vm.stock.city.name ? _vm.stock.city.name : ''),
      "label": "Город",
      "display-property": "label",
      "property": "id",
      "name": "city_id",
      "id": "city_id",
      "data-vv-name": "city_id",
      "required": "",
      "data-vv-as": ' ',
      "error": _vm.errors.first('city_id'),
      "placeholder": "Введите наименование города/населенного пункта"
    },
    model: {
      value: (_vm.stock.city_id),
      callback: function($$v) {
        _vm.$set(_vm.stock, "city_id", $$v)
      },
      expression: "stock.city_id"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:2|max:255'),
      expression: "'min:2|max:255'"
    }],
    attrs: {
      "name": "description",
      "id": "description",
      "label": "Описание",
      "data-vv-name": "description",
      "data-vv-as": ' ',
      "error": _vm.errors.first('description')
    },
    model: {
      value: (_vm.stock.description),
      callback: function($$v) {
        _vm.$set(_vm.stock, "description", $$v)
      },
      expression: "stock.description"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.stock.printers && _vm.stock.printers.length && _vm.activeTab === 'tab-printers') ? _c('stock-printers', {
    attrs: {
      "value": _vm.stock.printers
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stock.id && _vm.stock.id != 'new' && _vm.activeTab === 'tab-zones') ? _c('z-input-stock-zones', {
    ref: "zones",
    attrs: {
      "stock": _vm.stock
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stock.id && _vm.stock.id != 'new' && _vm.activeTab === 'tab-history') ? _c('comments-and-logs', {
    ref: "history",
    attrs: {
      "entity_id": parseInt(_vm.stock.id),
      "entity": "stoсks",
      "module": "stoсks"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c29cbdc6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/Stock.vue
// module id = 1252
// module chunks = 0